<template>
  <el-dialog
    title="添加检索关键词"
    :visible.sync="storeAlinkShow"
    :close-on-click-modal="false"
    width="640px"
    id="dialog">
    <el-row style="box-sizing: border-box;max-height: 595px;overflow:auto;">

      <div class="seaerch-wrapper">
        <el-form :label-width="labelWidth" id="shopLink">

          <el-form-item label="关键词" prop="arrLink" class="require">
            <div class="link_content">
              <div class="link_div_container">
                <div
                  class="link_div"
                  v-for="(item,index) in ruleForm.arrLink"
                  :key="index"
                  v-show="ruleForm.arrLink.length>0"
                >
                  <span
                    v-show="!linkEditShow[index]"
                    :class="ifcheckLink[index]==false?'redlink':''"
                    class="ellipsis"
                  >{{item}}</span>
                  <el-input
                    v-model="link"
                    size="small"
                    v-show="linkEditShow[index]"
                    @blur="blurEditLink(index)"
                  ></el-input>
                  <div style="width: 34px;">
                    <i class="el-icon-edit-outline" @click="editeLink(index)"></i>
                    <i class="el-icon-close" @click="removeLink(index)"></i>
                  </div>
                </div>

              </div>
              <el-input
                clearable
                v-model="ruleForm.link"
                size="small"
                placeholder="一行一个，可多个，最多20个。"
                @blur="blurLink"
              ></el-input>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </el-row>
    <span slot="footer">
      <el-button size="small" type="primary" @click="sure">确 定</el-button>
      <el-button size="small" type="TheCustom" @click="storeAlinkShow = false">取 消</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { getItemId } from "@/libs/index";

export default {
  props: {

  },
  data() {
    return {
      labelWidth: '100px',
      ruleForm: {
        arrLink: [],
        link: "" //用户输入的链接
      },
      linkEditShow: [],
      ifcheckLink: [], //判断是否验证通过
      checkLink: [], //验证的链接
      link: "",
      storeAlinkShow: false,
    };
  },
  methods: {
    faOpen(data) {
      console.log(data)
      this.storeAlinkShow = true
      this.link = ''
      this.ruleForm.link = ''
      this.ruleForm.arrLink = []
      if (data.productsData && data.productsData.length > 0) {
        for (let a in data.productsData) {
          this.ruleForm.arrLink.push(data.productsData[a].shopnamechild)
        }
      } else {
        this.ruleForm.arrLink = []
      }
    },
    editeLink(index) {
      //编辑链接
      this.linkEditShow.forEach((item, i) => {
        if (i == index) {
          this.$set(this.linkEditShow, i, true);
        } else {
          this.$set(this.linkEditShow, i, false);
        }
      });
      this.link = this.ruleForm.arrLink[index];
    },
    blurLink() {
      console.log(this.ruleForm.link)
      if (this.ruleForm.arrLink.length == 20) {
        this.$message({
          message: '关键词最多不超过20个',
          type: 'warning'
        });
        return;
      }
      this.linkEditShow = []
      //链接输入框失去焦点，处理数据
      if (this.ruleForm.link) {
        if (this.ruleForm.link.indexOf(' ') != -1) {
          let arr = []
          arr = this.ruleForm.link.split(' ')
          for (let a in arr) {
            if (a == 20) {
              this.$message({
                message: '关键词最多不超过20个',
                type: 'warning'
              });
              return;
            }
            this.ruleForm.arrLink.push(arr[a])
          }
        } else {
          this.ruleForm.arrLink.push(this.ruleForm.link);
        }
        if (this.ruleForm.arrLink.length > 0) {
          for (let a in this.ruleForm.arrLink) {
            this.linkEditShow.push(false);
          }
        }
      }
      this.ruleForm.link = ''
    },
    blurEditLink(index) {
      console.log(this.link)
      this.ruleForm.arrLink[index] = this.link
      this.$set(this.linkEditShow, index, false);
    },
    // 验证是否符合规则
    sure() {

      if (this.ruleForm.arrLink.length == 0) {
        this.$message({
          message: '请填写关键词',
          type: 'warning'
        });
        return;
      }
      let arr = []
      arr = Array.from(new Set(this.ruleForm.arrLink))
      console.log(arr)
      let params={
        shopnames: arr.join(','),
      }
      this.ruleForm.arrLink = arr
      console.log(this.ruleForm.arrLink)
      this.storeAlinkShow = false
      let faData = []
      for (let a in this.ruleForm.arrLink) {
        faData.push({
          shopnamechild: this.ruleForm.arrLink[a]
        })
      }
      console.log(faData)
      this.$emit('fromChild', faData)
    },

    removeLink(index) {
      //删除链接
      this.ruleForm.arrLink.splice(index, 1);
      this.ifcheckLink.splice(index, 1);
      this.$emit("delFalseLink", index);
    },
  }
};
</script>
<style lang="scss">
.tagStyle {
  background-color: #fdf6ec;
  border-color: #faecd8;
  color: #e6a23c;
  display: inline-block;
  padding: 0 10px;
  line-height: 30px;
  font-size: 12px;
  border-width: 1px;
  border-style: solid;
  border-radius: 4px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  white-space: nowrap;
  width: 100%;
}
#shopLink {
  .ellipsis {
    width: 90%;
  }
  .link_content {
    padding: 10px;
    border: 1px solid #dcdfe6;
    height: 252px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    width: 440px;
    .link_div_container {
      max-height: 200px;
      overflow-y: auto;
    }
    .el-input__inner {
      border: none;
    }
  }
  .require .el-form-item__label {
    &::before {
      content: "*";
      color: #f56c6c;
      margin-right: 4px;
    }
  }
  .link_div {
    height: 24px;
    line-height: 24px;
    border: 1px solid #dcdfe6;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    justify-content: space-between;
    padding-right: 5px;
    box-sizing: border-box;
    margin-bottom: 5px;
    border-radius: 4px;
    .el-input--small .el-input__inner {
      height: 18px;
      line-height: 18px;
      border: none;
    }
  }
  .el-icon-edit-outline {
    font-size: 14px;
    color: #108cee;
  }
  .redlink {
    color: red;
  }
  #dialog {
    .el-button--primary {
      color: #FFF;
      background-color: #bda571;
      border-color: #bda571;
    }
    .el-button--primary:hover {
      color: #FFF;
      background-color: #c0ae8a;
      border-color: #c0ae8a;
    }
  }
  .el-button--TheCustom {
    color: #666;
    border-color: #D9D9D9;
    background-color: #fff;
  }
  .el-button--TheCustom:hover  {
    color: #666;
    border-color: #ded2b8;
    background-color: #faf9f5;
  }
}
</style>
